export default {"src":"/_next/static/media/logo.b64cf58f.svg","height":634,"width":1488,"blurWidth":0,"blurHeight":0};